module.exports = __webpack_public_path__ + "static/media/delantal (5).5528972f.jpg";